<template>
  <section class="preview">
    <Spinner />
  </section>
</template>
<script>
import Prismic from 'prismic-javascript';
import linkResolver from '@/prismic/link-resolver';
import PrismicConfig from '../../../prismic.config';
import Spinner from '../Spinner';

export default {
  name: 'Preview',
  components: {
    Spinner
  },
  beforeCreate() {
    const previewToken = this.$route.query.token;

    Prismic.getApi(PrismicConfig.endpoint)
      .then(api => api.previewSession(previewToken, linkResolver, '/'))
      .then(url => {
        this.$router.push(url);
      });
  }
};
</script>
<style lang="scss" scoped>
.preview {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  min-height: calc(100vh - 60px - 510px);
}
</style>
